import React from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { ResponsibleFor } from "..";

import { Transfer, TransferType } from "../../types";

import styles from "./TransferDetailsLocationsSection.module.scss";

export interface Props {
  transfer: Transfer;
  isStaffView: boolean;
  flags: React.ReactNode | React.ReactNodeArray;
}

const TransferDetailsLocationsSection = ({
  transfer,
  isStaffView,
  flags,
}: Props) => {
  const {
    transferType,
    syncedDate,
    completedDate,
    actualTransactionDate,
  } = transfer;
  const { t } = useTranslation();

  const showSyncedOn = [
    TransferType.PickupFromStorage,
    TransferType.DeliveryToStorage,
  ];

  const showWriteOffDateOn = [
    TransferType.NonEligibleWriteOff,
    TransferType.NonEligibleBufferWriteOff,
  ];

  const renderEvent = (
    titleKey: string,
    dateString: string,
    showTime = true
  ) => {
    const date = new Date(dateString);

    return (
      <div key={titleKey} className={styles.dateItem}>
        <span>{t(`transfers.details.eventTitles.${titleKey}`)}</span>
        <span className={styles.dateLine}>{format(date, "MMM d, yyyy")}</span>
        {showTime && (
          <span className={styles.timeline}>{format(date, "h:mm a")}</span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.transactionDataWrapper}>
      <div className={styles.sectionActionContainer}>
        <div className={styles.transactionDataContainer}>
          <div className={styles.transactionHeader}>
            <h2>{t(`transfers.header.${transferType}.header`)}</h2>
            <span>{t(`transfers.header.${transferType}.subheader`)}</span>
          </div>
          <div className={styles.dateDeliveryWrapper}>
            <ResponsibleFor transfer={transfer} isStaffView={isStaffView} />
            <div className={styles.dateDeliveryWrapper}>
              {completedDate && renderEvent("Completed", completedDate)}
              {syncedDate &&
                showSyncedOn.includes(transferType) &&
                renderEvent("Synced", syncedDate)}
              {actualTransactionDate &&
                showWriteOffDateOn.includes(transferType) &&
                renderEvent("WriteOffDate", actualTransactionDate, false)}
            </div>
          </div>
        </div>
      </div>
      {flags}
    </div>
  );
};

export default TransferDetailsLocationsSection;
